import React from 'react';
import classnames from 'classnames';
import styles from './SectionPanel.module.scss';

export interface SectionPanelProps {
  children: React.ReactNode,
  line?: 'top' | 'bottom' | 'both'
  className?: string,
}

const SectionPanel = ({className, line, children}: SectionPanelProps) => {
  return (
    <div
      className={classnames(styles.panel, {
          [styles.bottomLine]: line === 'bottom',
          [styles.topLine]: line === 'top',
          [styles.bothLines]: line === 'both'
        }, className)}
    >
      {children}
    </div>
  );
};

export default SectionPanel;
